import React from "react";

// Lightweight SVG donut — no chart library, prints cleanly and scales.
export default function ScoreDonut({
  value, max = 100, size = 150, stroke = 14, color = "#2e8b63",
  track = "#e7e4dd", label, sublabel, testId,
}) {
  const pct = value == null || !max ? 0 : Math.max(0, Math.min(1, value / max));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={track} strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - pct)}
          style={{ transition: "stroke-dashoffset 900ms cubic-bezier(.22,.9,.3,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center leading-none">
        <span className="font-editorial" style={{ fontSize: size * 0.3 }}>
          {value == null ? "—" : value}
        </span>
        {max ? <span className="text-xs text-muted-foreground mt-1">/ {max}</span> : null}
        {label ? <span className="text-[10px] uppercase tracking-wider mt-1">{label}</span> : null}
        {sublabel ? <span className="text-[10px] text-muted-foreground">{sublabel}</span> : null}
      </div>
    </div>
  );
}
